import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=c3377fc6&scoped=true"
import script from "./table4.vue?vue&type=script&lang=js"
export * from "./table4.vue?vue&type=script&lang=js"
import style0 from "./table4.vue?vue&type=style&index=0&id=c3377fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3377fc6",
  null
  
)

export default component.exports